(function(){
        if (!document.getElementById('aa0b21ae74b8153a017c3659bca290d5aa748d8b3e63a38a277cac2d21fe6d4d')) {
            var e = document.createElement('style');
            e.id = 'aa0b21ae74b8153a017c3659bca290d5aa748d8b3e63a38a277cac2d21fe6d4d';
            e.textContent = `:root {
  --color: #e0e0e0;
  --color-hover: #f9f9f9;
}

#content {
  height: 0;
}

#content > .margin {
  padding: 2rem;
}

TABLE {
  border: none;
  border-collapse: collapse;
  width: 100%;
}

.new-item TD,
.move-item TD {
  vertical-align: top;
}

.new-item TD.data,
.move-item TD.data {
  width: 50rem;
}

.new-item DIV.label,
.new-item TD.label,
.move-item DIV.label,
.move-item TD.label {
  padding-top: 1.5rem;
}

.new-item TD.buttons,
.move-item TD.buttons {
  text-align: right;
}

.new-item TD.section {
  text-align: center;
  font-weight: bold;
  padding: 2rem;
}

TR {
  border-bottom: 1px solid var(--color);
  vertical-align: middle;
  transition: background-color 0.15s ease;
}

TR:hover {
  background-color: var(--color-hover);
}

TD.no-alias {
  color: #9e9e9e;
}

.action {
  white-space: nowrap;
  display: flex;
  align-items: center;
}

TH {
  background-color: transparent;
  color: #757575;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 0.5rem 1rem;
  border-bottom: 2px solid var(--color);
}

ADDRESS {
  font-style: normal;
  cursor: pointer;
}

.mobile-table,
.mobile-table TR,
.mobile-table TD {
  padding: 0;
  border: 0;
}

.mobile-table ADDRESS {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 210px;
}

.mobile-title {
  font-weight: bold;
  margin-bottom: 0.5em;
}

.mobile-title ADDRESS {
  margin-bottom: 0;
}

.chips {
  display: flex;
  gap: 0.5em;
  justify-content: center;
  margin-bottom: 1em;
}

.search-not-found {
  display: flex;
  min-height: 40px;
  align-items: center;
  color: #9e9e9e;
  font-style: italic;
}

@media only screen and (max-width: 600px) {
  .mobile-table TD:nth-child(1) {
    width: 100%;
    text-align: right;
  }
}

.groups {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 1.25rem;
}

.MuiContainer-root {
  padding: 0;
}
`;
            document.head.appendChild(e);
        }
    })();